import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';

// Components
import { cn } from 'utils';
import { Picto } from '../Picto/Picto';

// Utils

// Styles
import styles from './HelpBoxInteractive.module.css';

// Hooks
import useResponsiveQueries from '../../../src/hooks/useResponsiveQueries';

function HelpBoxInteractive({
  title, children, isExpandedByDefault,
}) {
  const { isMobile } = useResponsiveQueries();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(isExpandedByDefault);
  }, [isExpandedByDefault]);

  return (
    <div className={cn([styles.help])}>
      <button
        type="button"
        className={styles.interactive}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className={styles.content}>
          <h3 className={styles.title}>
            {title}
          </h3>
        </div>
        <Picto icon="chevronDown" className={cn([styles.picto, isExpanded && styles.pictoActive])} />
      </button>
      <AnimatePresence initial={false}>
        {isExpanded ? (
          <motion.div
            className={styles.children}
            initial={{
              opacity: 0,
              height: 0,
              transform: isMobile ? 'translateX(16px)' : 'translateY(30px)',
            }}
            animate={{
              opacity: 1,
              height: 'auto',
              transform: isMobile ? 'translateX(0)' : 'translateY(0)',
            }}
            exit={{
              opacity: 0,
              height: 0,
              transform: isMobile ? 'translateX(16px)' : 'translateY(20px)',
            }}
            transition={{ duration: 0.3 }}
          >
            {children(isExpanded)}
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}

HelpBoxInteractive.propTypes = {
  title: PropTypes.string,
  children: PropTypes.func,
  isExpandedByDefault: PropTypes.bool,
};

HelpBoxInteractive.defaultProps = {
  title: '',
  children: () => {},
  isExpandedByDefault: false,
};

export default HelpBoxInteractive;
